export const linkedInProfileRegex = /^(https?:\/\/)?(www\.)?linkedin.com\/in\/([-a-zA-Z0-9]+)/
